<template>
  <div>
    <el-dialog
      title="新增证照信息"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <el-form size="small" class="form-centent">
        <div class="row">
          <div class="tip commo-text-ideograph">证照类型</div>
          <div class="value">
            <el-input v-model="formIn.certificateType" maxlength="20" />
          </div>
        </div>
        <div class="row">
          <div class="tip commo-text-ideograph">证照编号</div>
          <div class="value">
            <el-input v-model="formIn.certificateCode" maxlength="30" />
          </div>
        </div>
        <div class="row">
          <div class="tip commo-text-ideograph">证照图</div>
          <div class="value">
            <div class="public-pic-layout">
              <div class="item" v-if="formIn.certificateImage">
                <el-image
                  ref="myImg"
                  :src="formIn.certificateImage"
                  fit="cover"
                  class="icon"
                  :initial-index="index"
                  :preview-src-list="[formIn.certificateImage]"
                />
                <div class="preview">
                  <el-image
                    :src="SeeIcon"
                    class="btn-icon"
                    @click="handlePreview(`myImg`)"
                  />
                  <el-image
                    :src="DelIcon"
                    class="btn-icon"
                    @click="handleDeleteImage()"
                  />
                </div>
              </div>
              <div v-else class="item add-pic" @click="handleUpload()">
                <div class="image-wrap">
                  <el-image :src="AddIcon" />
                </div>
                <span class="text">上传图片</span>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitUpload()">确认</el-button>
      </span>
    </el-dialog>

    <UploadImageView
      ref="imgupload"
      request-id="1"
      :imgType="imgType"
      @upload="uploadSubmit"
    />
  </div>
</template>
<script>
import UploadImageView from "@/views/businessManage/checkShop/components/UploadImage.vue";
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

export default {
  components: { UploadImageView },
  props: {
    requestId: {
      type: String,
      default: () => "",
    },

    limit: {
      type: Number,
      default: () => 10,
    },
  },
  computed: {
    headers: function () {
      return {
        Authorization: "Bearer " + getToken(),
      };
    },
  },
  data() {
    return {
      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      imgType: "",
      IConst_Max_Pic_Count: 5,

      dialogVisible: false,
      formIn: {
        certificateType: "",
        certificateCode: "",
        certificateImage: "",
      },
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    handleUpload() {
      this.$refs.imgupload.open(this.imgType);
    },
    uploadSubmit(obj) {
      const { type, url } = obj;
      this.formIn.certificateImage = url;
    },
    handlePreview(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].showViewer = true;
      }
    },
    handleDeleteImage() {
      this.formIn.certificateImage = "";
    },

    submitUpload() {
      if (!this.formIn.certificateType) {
        this.$message.warning("请输入证件类型");
        return;
      }
      if (!this.formIn.certificateCode) {
        this.$message.warning("请输入证件编码");
        return;
      }
      if (!this.formIn.certificateImage) {
        this.$message.warning("请上传证件图片");
        return;
      }
      this.$emit("addLicenses", this.formIn);
      this.dialogVisible = false;
    },
    clear() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
    },
    open() {
      this.clear();
      this.dialogVisible = true;
    },
  },
};
</script>
<style scoped lang="scss">
.form-centent {
  .row {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .tip {
      width: 4em;
    }

    .value {
      width: 240px;
      margin-left: 8px;

      & > * {
        width: 100%;
      }
    }
  }
}
</style>
